/**
 * Client-side URL tracking utility
 * Tracks the last visited valid URL for better 404 redirects
 */

export class UrlTracker {
  private static readonly STORAGE_KEY = 'lastVisitedUrl'
  private static readonly EXCLUDED_PATHS = [
    '/not-found',
    '/unauthorized',
    '/auth',
    '/payment/success',
    '/payment/failure',
    '/payment/error',
    '/payment/cancelled'
  ]

  /**
   * Track the current URL if it's a valid page
   */
  static trackCurrentUrl() {
    if (typeof window === 'undefined') return

    const currentPath = window.location.pathname
    
    // Don't track excluded paths
    if (this.EXCLUDED_PATHS.some(path => currentPath.startsWith(path))) {
      return
    }

    // Don't track dynamic routes that might be invalid
    if (currentPath.includes('/undefined') || currentPath.includes('/null')) {
      return
    }

    sessionStorage.setItem(this.STORAGE_KEY, currentPath)
  }

  /**
   * Get the last visited URL
   */
  static getLastVisitedUrl(): string | null {
    if (typeof window === 'undefined') return null
    return sessionStorage.getItem(this.STORAGE_KEY)
  }

  /**
   * Clear the tracked URL
   */
  static clearLastVisitedUrl() {
    if (typeof window === 'undefined') return
    sessionStorage.removeItem(this.STORAGE_KEY)
  }

  /**
   * Get role-based default redirect
   */
  static getRoleBasedRedirect(role?: string): string {
    switch (role) {
      case 'ADMIN':
        return '/admin'
      case 'MERCHANT':
        return '/dashboard'
      case 'REFERRAL':
        return '/referral/dashboard'
      case 'CUSTOMER_SUCCESS':
        return '/cs'
      default:
        return '/'
    }
  }
}
